export default __webpack_public_path__ + "static/media/snowy-6.dce3f5e7.svg";